import { RRNLRequestError } from 'react-relay-network-modern'

/**
 * Joins all the error messages into one string, using a newline as the separator.
 * If `err.res.errors` doesn't exist, it will default to `err.message`.
 **/
export function joinAllRRNLErrors(err: RRNLRequestError) {
  return err.res?.errors?.map((err) => err.message).join('\n') ?? err.message
}

/**
 * Extracts the first readable error message from the error response.
 */
export function extractFirstReadableError(err: RRNLRequestError) {
  return err.res?.errors?.[0]?.message ?? err.message
}

/**
 * A generic error handler for Relay hooks.
 *
 * @param err The error that occurred
 * @returns The error message to display to the user
 */
export const getRelayHookError = (err: Error) => {
  if (err instanceof RRNLRequestError) {
    return extractFirstReadableError(err)
  } else {
    return err.message
  }
}
